<template lang="html">
  <div id="d-evaluations-page">

    <section class="short-info-section-s1">
      <div class="box-top">
        <div class="col-sm-6 col-title">
          <h2>Capacitaciones</h2>
        </div>

        <div class="col-sm-6 col-buttons">
          <a class="btn btn-s1 bg-red" @click="$refs['modal-request'].show();">Enviar comentarios</a>
        </div>
      </div>
    </section>

    <section class="evaluations-section">

      <!-- Conocimiento -->
      <div class="row row-evaluation">
        <div class="col-md-7 col-text">
          <h5 class="title">Conocimiento</h5>

          <div class="descr">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>

        <div class="col-md-5 col-chart">
          <vc-donut :size="212" unit="px" :thickness="18" :sections="conocimientoObj">
            <span class="chart-number">{{ conocimientoObj[0].value }}</span>
          </vc-donut>
        </div>
      </div>
      <!--  -->

      <!-- Etica -->
      <div class="row row-evaluation">
        <div class="col-md-7 col-text">
          <h5 class="title">Etica</h5>

          <div class="descr">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>

        <div class="col-md-5 col-chart">
          <vc-donut :size="212" unit="px" :thickness="18" :sections="eticaObj">
            <span class="chart-number">{{ eticaObj[0].value }}</span>
          </vc-donut>
        </div>
      </div>
      <!--  -->

      <!-- Desempeño -->
      <div class="row row-evaluation">
        <div class="col-md-7 col-text">
          <h5 class="title">Desempeño</h5>

          <div class="descr">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>

        <div class="col-md-5 col-chart">
          <vc-donut :size="212" unit="px" :thickness="18" :sections="desempenoObj">
            <span class="chart-number">{{ desempenoObj[0].value }}</span>
          </vc-donut>
        </div>
      </div>
      <!--  -->

      <!-- Puntualidad -->
      <div class="row row-evaluation">
        <div class="col-md-7 col-text">
          <h5 class="title">Puntualidad</h5>

          <div class="descr">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
            </p>
          </div>
        </div>

        <div class="col-md-5 col-chart">
          <vc-donut :size="212" unit="px" :thickness="18" :sections="puntualidadObj">
            <span class="chart-number">{{ puntualidadObj[0].value }}</span>
          </vc-donut>
        </div>
      </div>
      <!--  -->

    </section>

    <b-modal modal-class="modal-request-s1" ref="modal-request" title="Comentarios acerca de evaluaciones" size="lg" centered hide-footer>
      <b-form @submit="onSubmitForm">
        <b-form-group class="form-group-s1"
          label="Comentarios">
          <b-form-textarea
            required
            v-model="formModal.comentarios"
            placeholder="Ingresa los comentarios"
            rows="9"
            max-rows="9"
          ></b-form-textarea>
        </b-form-group>

        <b-button type="submit" class="btn-s1 bg-red btn-lg mt-2 w-100">Enviar</b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
export default {
  data() {
    return {
      formModal: {
        comentarios: null,
      },

      conocimientoObj: [{ value: 55, color: '#8a0e0a' }],
      eticaObj: [{ value: 70, color: '#8a0e0a' }],
      desempenoObj: [{ value: 60, color: '#8a0e0a' }],
      puntualidadObj: [{ value: 100, color: '#8a0e0a' }],
    };
  },

  methods: {
    onSubmitForm(event) {
      event.preventDefault();
    },
  }
}
</script>
